// CSS
import "@/assets/css/rental-service.scss";
import "@/assets/responsive/rental-service.scss";
//Lib
import { mapState } from "vuex";

// Event, Dialog
import EventBus from "@/event/EventBus";
import commonActionHandle from "@/commonActionHandle";

// Api
import api from "@/api/baseApi";

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { SERVICE_TYPE, MACHINE_LIST_FILTER_BY } from "@/constant/rental";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { POPUP_ID, POPUP_NAME } from "@/constant/baseConstant";

// Extend
import base from "@/scripts/base";

// Components
import Controller from "@/views/component/RentalService/Controller";
import lazyLoadComponent from "@/scripts/lazyLoadComponent";
import SkeletonBox from "@/views/component/SkeletonBox";
// import RightPanel from "@/views/component/RentalService/RightPanel";

import InformationBasic from "@/views/component/RentalService/InformationBasic";
import NoMachineAvailable from "@/views/component/RentalService/Notification/NoMachineAvailable";
import BalanceNotEnough from "@/views/component/RentalService/Notification/BalanceNotEnough";
import NoDeposit from "@/views/component/RentalService/Notification/NoDeposit";
import LimitImage from "@/views/component/RentalService/Notification/LimitImage";

// Function
const queryString = require("query-string");

// import {
//     socketIOEvents
// } from "@/constant/config";
// const regrexPercentClone = /^(\w+): ([a-zA-Z0-9-]+) - (\w+): ([a-zA-Z0-9-]+) - Message: \[(\d+), (\w+)] - clone image: ([\w.]+)%$/;

import { BOOT_MACHINE_STATUS } from "@/constant/rental";

export default {
  extends: base,

  components: {
    Controller,
    ItemDesktop: lazyLoadComponent({
      componentFactory: () => import("@/views/RentalService/ItemDesktop"),
      loading: SkeletonBox,
    }),
    ItemMobile: lazyLoadComponent({
      componentFactory: () => import("@/views/RentalService/ItemMobile"),
      loading: SkeletonBox,
    }),

    InformationBasic,
    NoMachineAvailable,
    BalanceNotEnough,
    NoDeposit,
    LimitImage,
  },

  data() {
    return {
      timeForCreatingImage: 2000,
      machineList: [],
      machineListRequest: {
        serviceType: SERVICE_TYPE.GPUHUB,
        filterBy: MACHINE_LIST_FILTER_BY.ALL,
        searchString: null,
        orderBy: "A.CREATED_AT",
        directionSort: "DESC",
      },
      debonceFnSearchTyping: null,
      currentMachineId: null,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      serverReport: (state) => state.common.serverReport,
    }),
    booMultiIsValid() {
      const imageCheckedValid = this.machineList.filter((x) => x.checked && !((x.packageId === "25" || x.packageId === "30") && !x.fixedRental));
      return imageCheckedValid.length > 0;
    },
  },
  created() {
    EventBus.$on("updateMachineState", (data) => {
      if (data && data.machineId && data.targetState) {
        const foundMachine = this.machineList.find((x) => x.id === data.machineId);
        if (foundMachine !== undefined && foundMachine !== null) {
          this.$set(foundMachine, "status", data.targetState);
        }
      }
    });

	EventBus.$off("cctxMnMbProcessingEvent");
    EventBus.$on("cctxMnMbProcessingEvent", (param) => {
		this.processingEvent(param)
	});
  },
  beforeDestroy() {
    EventBus.$off("updateMachineState");
    //EventBus.$off("cctxMnMbProcessingEvent");
  },
  methods: {
    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion

    checkImage() {
      //let listCheck = this.machineList.filter(x => x.checked);
      // if (listCheck.length > 0) {
      // } else {
      // }
    },

    //#region Action
    action(param) {
      let action = this.$action;
      switch (param.type) {
        case action.BOOT_IMAGE_MULTI: {
          let imageChecked = this.machineList.filter((x) => x.checked);
          this.$confirm(`Make sure you boot the ${imageChecked.length} selected images. Continue?`, "Confirm boot multiple image", {
            confirmButtonText: `Yes, boot ${imageChecked.length} image${imageChecked.length > 1 ? "s" : ""}`,
            cancelButtonText: "Cancel",
            type: "warning",
          })
            .then(() => {
              this.machineList
                .filter((x) => x.checked && !((x.packageId === "25" || x.packageId === "30") && !x.fixedRental))
                .forEach((element) => {
                  this.boot(element.id);
                  element.checked = false;
                });

              this.machineList
                .filter((x) => x.checked && (x.packageId === "25" || x.packageId === "30") && !x.fixedRental)
                .forEach((element) => {
                  this.notificationError(`Boot ${element.id} ignored... !`, `Boot ignored. Image ${element.id} is belong package that is allowed only Rental Plan!`);
                  element.checked = false;
                });
            })
            .catch(() => {});
          break;
        }
        case action.CLICK_REFRESH_MACHINE_LIST_VIEW:
          this.machineListRequest.searchString = "";
          this.machineListView();
          break;

        case action.SEARCH_TYPING_MACHINE_LIST_VIEW_IMMEDIATELY:
          if (this.isLoading) return;
          this.machineListView();
          break;
        case action.SEARCH_TYPING_MACHINE_LIST_VIEW:
          if (this.isLoading) return;
          this.debonceFnSearchTyping();
          break;

        // Fixed rental
        case action.OPEN_POPUP_FIXED_RENTAL_CREATE:
          this.processOpenPopup(POPUP_ID.FIXED_RENTAL_CREATE, POPUP_NAME.FIXED_RENTAL_CREATE, param.data);
          break;
        case action.OPEN_POPUP_FIXED_RENTAL_EXISTING_MACHINE:
          this.processOpenPopup(POPUP_ID.FIXED_RENTAL_EXISTING_MACHINE, POPUP_NAME.FIXED_RENTAL_EXISTING_MACHINE);
          break;
        case action.OPEN_POPUP_FIXED_RENTAL_RENEWAL_MACHINE:
          this.processOpenPopup(POPUP_ID.FIXED_RENTAL_RENEWAL_MACHINE, POPUP_NAME.FIXED_RENTAL_RENEWAL_MACHINE, param.data);
          break;
        case action.OPEN_POPUP_FIXED_RENTAL_DEACTIVATE:
          this.processOpenPopup(POPUP_ID.FIXED_RENTAL_DEACTIVATE, POPUP_NAME.FIXED_RENTAL_DEACTIVATE, param.data);
          break;
        case action.OPEN_POPUP_FIXED_RENTAL_SETTINGS:
          this.processOpenPopup(POPUP_ID.FIXED_RENTAL_SETTINGS, POPUP_NAME.FIXED_RENTAL_SETTINGS, param.data);
          break;

        // Rental
        case action.OPEN_POPUP_CREATE_IMAGE:
          this.processOpenPopup(POPUP_ID.CREATE_IMAGE, POPUP_NAME.CREATE_IMAGE, param.data);
          break;
        case action.OPEN_POPUP_BOOT_MACHINE:
          this.processOpenPopup(POPUP_ID.BOOT_MACHINE, POPUP_NAME.BOOT_MACHINE, param.data);
          break;
        case action.OPEN_POPUP_DOWNLOAD_REMOTE_DESKTOP:
          this.processOpenPopup(POPUP_ID.DOWNLOAD_REMOTE_DESKTOP, POPUP_NAME.DOWNLOAD_REMOTE_DESKTOP, param.data);
          break;
        case action.OPEN_POPUP_CLONE_IMAGE:
          this.processOpenPopup(POPUP_ID.CLONE_IMAGE, POPUP_NAME.CLONE_IMAGE, param.data);
          break;
        case action.OPEN_POPUP_CHANGE_SERVICE_PACKAGE:
          this.processOpenPopup(POPUP_ID.CHANGE_SERVICE_PACKAGE, POPUP_NAME.CHANGE_SERVICE_PACKAGE, param.data);
          break;
        case action.OPEN_POPUP_RENAME_IMAGE:
          this.processOpenPopup(POPUP_ID.RENAME_IMAGE, POPUP_NAME.RENAME_IMAGE, param.data);
          break;
        case action.OPEN_POPUP_SNAPSHOT_IMAGE:
          this.processOpenPopup(POPUP_ID.SNAPSHOT_IMAGE, POPUP_NAME.SNAPSHOT_IMAGE, param.data);
          break;
        case action.OPEN_POPUP_REMOVE_IMAGE:
          this.processOpenPopup(POPUP_ID.REMOVE_IMAGE, POPUP_NAME.REMOVE_IMAGE, param.data);
          break;
        case action.OPEN_POPUP_SHUTDOWN_MACHINE:
          this.processOpenPopup(POPUP_ID.SHUTDOWN_MACHINE, POPUP_NAME.SHUTDOWN_MACHINE, param.data);
          break;
        case action.OPEN_POPUP_HARDWARE_FIXATION:
          this.processOpenPopup(POPUP_ID.HARDWARE_FIXATION, POPUP_NAME.HARDWARE_FIXATION, param.data);
          break;
        case action.OPEN_POPUP_SCHEDULER_MACHINE:
          this.processOpenPopup(POPUP_ID.SCHEDULER_MACHINE, POPUP_NAME.SCHEDULER_MACHINE, param.data);
          break;
        case action.OPEN_POPUP_RESTART_MACHINE:
          this.processOpenPopup(POPUP_ID.RESTART_MACHINE, POPUP_NAME.RESTART_MACHINE, param.data);
          break;
        case action.OPEN_POPUP_RESET_MACHINE:
          this.processOpenPopup(POPUP_ID.RESET_MACHINE, POPUP_NAME.RESET_MACHINE, param.data);
          break;
        case action.OPEN_POPUP_DISCONNECT_INTERNET_MACHINE:
          this.processOpenPopup(POPUP_ID.DISCONNECT_INTERNET_MACHINE, POPUP_NAME.DISCONNECT_INTERNET_MACHINE, param.data);
          break;
        case action.OPEN_POPUP_ACTIVATE_SOFTWARE_LICENSE:
          this.processOpenPopup(POPUP_ID.ACTIVATE_SOFTWARE_LICENSE, POPUP_NAME.ACTIVATE_SOFTWARE_LICENSE, param.data);
          break;
        case action.OPEN_POPUP_PROCESS_MONITORING:
          this.processOpenPopup(POPUP_ID.PROCESS_MONITORING, POPUP_NAME.PROCESS_MONITORING, param.data);
          break;
        case action.OPEN_POPUP_SETTINGS_MACHINE:
          this.processOpenPopup(POPUP_ID.SETTINGS_MACHINE, POPUP_NAME.SETTINGS_MACHINE, param.data);
          break;

        // Extra service
        case action.OPEN_POPUP_EXTRA_SERVICE_REPORT_ISSUES:
          this.processOpenPopup(POPUP_ID.EXTRA_SERVICE_REPORT_ISSUES, POPUP_NAME.EXTRA_SERVICE_REPORT_ISSUES, param.data);
          break;
        case action.OPEN_POPUP_EXTRA_SERVICE_OPEN_PORT:
          EventBus.$emit("processingEventApp", {
            event: "processOpenPopup",
            data: {
              type: POPUP_ID.EXTRA_SERVICE_OPEN_PORT,
              name: POPUP_NAME.EXTRA_SERVICE_OPEN_PORT,
              data: param.data,
            },
          });
          break;
      }
    },
    //#endregion

    //#region Process open pop-up
    processOpenPopup(type, name, data, refresh) {
      console.log("🚀 ~ file: baseRentalService.js:254 ~ processOpenPopup ~ name:", name);
      if (refresh === undefined || refresh === null) refresh = true;
      this.$emit("processingEvent", {
        event: "processOpenPopup",
        data: {
          type: type,
          name: name,
          data: data,
          refresh: refresh,
        },
      });
    },
    //#endregion

    //#region Is loaing item
    isLoadingElement(listMachineId) {
      listMachineId.forEach((machineId) => {
        let itemTargetUpdated = this.machineList.find((element) => element.id === machineId);
        if (itemTargetUpdated !== undefined && itemTargetUpdated !== null) {
          this.$set(itemTargetUpdated, "isLoading", true);
        }
      });
    },
    //#endregion

    //#region Is stop loading item
    isStopLoadingElement(listMachineId) {
      listMachineId.forEach((machineId) => {
        let itemTargetUpdated = this.machineList.find((element) => element.id === machineId);
        if (itemTargetUpdated !== undefined && itemTargetUpdated !== null) {
          this.$set(itemTargetUpdated, "isLoading", false);
        }
      });
    },
    //#endregion

    //#region Selection image
    selectionImage(id) {
      this.currentMachineId = id;
      this.machineList.forEach((item) => {
        if (item.id === id) {
          this.$set(item, "isSelected", true);
        } else {
          this.$set(item, "isSelected", false);
        }
      });
    },
    //#endregion

    //#region Selection default image
    selectionDefaultImage() {
      if (this.machineList.length > 0) {
        if (this.machineList.find((x) => x.id === this.currentMachineId)) {
          this.$set(
            this.machineList.find((x) => x.id === this.currentMachineId),
            "isSelected",
            true
          );
        } else {
          this.currentMachineId = this.machineList[0].id;
          this.$set(this.machineList[0], "isSelected", true);
        }
      }
    },
    //#endregion

    //#region Boot machine
    boot(id) {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      setTimeout(() => {
        let data = {
          machineId: id,
          deviceInformation: JSON.stringify(this.getInformationClient()),
        };
        api
          .baseRequest(SETTINGS_RENTAL_API.BOOT_MACHINE, data)
          .then((res) => {
            switch (res.errorCode) {
              case BOOT_MACHINE_STATUS.SUCCESS: {
                EventBus.$emit("processingEventRental", {
                  event: "isLoadingElement",
                  data: [id],
                });
                EventBus.$emit("processingEventRental", {
                  event: "autoRefresh",
                });
                this.notificationSuccess("Booting... !", `Machine <span style="color: #42A5F5;"> #${id}</span> is booting...</span>`);
                let current = this.machineList.find((x) => x.id === id);
                if (current) {
                  current.checked = false;
                }
                break;
              }
              case BOOT_MACHINE_STATUS.BALANCE_NOT_ENOUGH:
                this.notificationError("Boot failed... !", `Your balance not enough !`);

                break;
              case BOOT_MACHINE_STATUS.TOTAL_RECHARGE_NOT_ENOUGH:
                this.notificationError("Boot failed... !", `Your balance not enough !`);

                break;
              case BOOT_MACHINE_STATUS.MACHINE_NOT_AVAILABLE:
                this.notificationError("Boot failed... !", `Machine <span style="color: #42A5F5;"> #${id}</span> not available...</span>`);

                break;
              case BOOT_MACHINE_STATUS.MAC_USED:
                this.notificationError("Boot failed... !", `Machine <span style="color: #42A5F5;"> #${id}</span> had used</span>`);

                break;
            }
            this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
          })
          .catch((error) => {
            this.processCatchApiRequest(error, "Boot failed ...");
          });
      }, 1000);
    },
    //#endregion

    //#region Set default value machine list
    setDefaultValueMachineList() {
      this.machineList.forEach((element) => {
        this.$set(element, "isSelected", false);
        // var startTimeDuration = moment.utc() - moment.utc((element.startTimeProcessing !== null ? element.startTimeProcessing : element.createdAt));
        // var percentCreating = (moment.duration(startTimeDuration).asSeconds() / this.timeForCreatingImage);
        // if (element.isCreating || element.isStarting) {
        //     if (percentCreating < 0.99) {
        //         element.percentLoad = percentCreating >= 0 ? percentCreating * 100 : 0;
        //     }
        //     else {
        //         element.percentLoad = 99;
        //     }
        // }
        // element.estimatedTotal = Math.round(((element.uptime * element.priceHour) / (60 * 60) + 0.00001) * 1000) / 1000;
        // if (element.uptime !== 0) {
        //     element.duration = this.caclDuration(element.uptime);
        // } else {
        //     element.duration = '0m';
        // }
      });
    },
    //#endregion

    //#region Auto refresh
    autoRefresh() {
      api
        .baseRequest(SETTINGS_RENTAL_API.MACHINE_LIST_VIEW, null, `?${queryString.stringify(this.machineListRequest)}`)
        .then((res) => {
          try {
            let data = res.data;
            data
              .filter(
                (x) =>
                  !this.serverReport
                    .map((item) => {
                      return item.packageId.toString();
                    })
                    .includes(x.packageId.toString())
              )
              .forEach((element) => {
                element.isNotSupport = true;
              });
            this.machineList = data;
            this.setDefaultValueMachineList();
            // this.selectionDefaultImage();
            this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
          } catch (error) {
            console.error(error);
          }
        })
        .catch((error) => {
          this.processCatchApiRequest(error, "Request failed ...", 5);
        });
    },
    //#endregion

    //#region Machine list view
    machineListView() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      api
        .baseRequest(SETTINGS_RENTAL_API.MACHINE_LIST_VIEW, null, `?${queryString.stringify(this.machineListRequest)}`)
        .then((res) => {
          let data = res.data;
          data
            .filter(
              (x) =>
                !this.serverReport
                  .map((item) => {
                    return item.packageId.toString();
                  })
                  .includes(x.packageId.toString())
            )
            .forEach((element) => {
              element.isNotSupport = true;
            });
          this.machineList = data;
          this.setDefaultValueMachineList();
          // this.selectionDefaultImage();
          this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
        })
        .catch((error) => {
          this.processCatchApiRequest(error, "Request failed ...");
        });
    },
    //#endregion

    //#region Rental request create
    baseRentalRequestCreate(data, machineEntity, callBack) {
      api
        .baseRequest(SETTINGS_RENTAL_API.RENTAL_REQUEST_CREATE, data)
        .then(() => {
          EventBus.$emit("processingEventRental", {
            event: "autoRefresh",
          });
          commonActionHandle.showCustomSuccess("Request success !", `Your request has been sent successfully. Our system will send you an email to notify you when ${machineEntity.packageName} is available`);
          if (callBack) callBack();
          this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
        })
        .catch((error) => {
          this.processCatchApiRequest(error, "Request failed ...");
        });
    },
    //#endregion
  },
};
